<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>特殊统计</span>
                        <span>销售额统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26156903"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="getExcel">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData">
                                <el-table-column width="120" prop="name" label="合同名称"></el-table-column>
                                <el-table-column prop="cost" label="销售额（单位:人民币/美元）">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.cost">{{ scope.row.cost }} {{ scope.row.costType | tableVal(costType) }}</span>
                                        <span v-if="scope.row.cost && scope.row.dollarCost">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                        <span v-if="scope.row.dollarCost">{{ scope.row.dollarCost }} {{ scope.row.costTypeOnce | tableVal(costType) }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../report.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                value:'',
                dimension:['product','人名币','美元'],
                options:{
                    tooltip : {
                        // trigger: 'item',
                        // formatter: function(params, ticket, callback){
                        //     return params.data[0]+'='+params.data[1]+'('+params.percent+'%)';
                        // }
                    },
                    xAxis: {type: 'category'},
                    yAxis: {},
                    legend: {},
                    dataset:{},
                    series: [
                        // {
                        //     type:'pie',
                        //     label: {
                        //         normal: {
                        //             formatter:function(params){
                        //                 return params.data[0]+'='+params.data[1]+'('+params.percent+'%)';
                        //             },
                        //         }
                        //     },
                        // },
                        {
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },

                    ]
                },
                getMes:{},
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 币种
            costType(){
                return this.dictionary.cost_type;
            },
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            getExcel(){
                let sendTableData = JSON.parse(JSON.stringify(this.tableData));
                let dataListLength = this.tableData.length - 1;
                sendTableData.forEach((item,index)=>{
                    if(index < dataListLength){
                        if(item.costType == '341'){
                            item.cost = item.cost + '美元';
                        }else if(item.costType == '339'){
                            item.cost = item.cost + '人民币';
                        }
                    }
                })
                let lastData = {
                    name: '合计',
                    cost: '',
                }
                let excelCnyMoney = this.tableData[dataListLength].cost?this.tableData[dataListLength].cost+'人民币':'';
                let excelDolMoney = this.tableData[dataListLength].dollarCost?this.tableData[dataListLength].dollarCost+'美元':'';
                lastData.cost = excelCnyMoney && excelDolMoney?excelCnyMoney+' | '+excelDolMoney:excelCnyMoney?excelCnyMoney:excelDolMoney?excelDolMoney:'';
                sendTableData[dataListLength] = lastData;
                let header = [];
                let filterVal = [];
                header = ['合同名称', '销售额（单位:人民币/美元）'];
                filterVal = ['name', 'cost'];
                const list = sendTableData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel({header,data,filename:`销售额统计${this.value[0]}—${this.value[1]}`});
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                }
                services.getContractStatisticsList(params).then(res=>{
                    let cnyMoney = 0;
                    let dollarMoney = 0;
                    res.tableData.forEach(item=>{
                        if(item.costType == '339'){
                            cnyMoney = cnyMoney+Number(item.cost);
                        }else if(item.costType == '341'){
                            dollarMoney = dollarMoney+Number(item.cost);
                        }
                    })
                    let pieData = [
                        // ['product',''],
                        // ['人民币','12'],
                        // ['美元','13'],
                    ]
                    let totleMoney = {
                        "name":"总计",
                        "cost":cnyMoney,
                        "costType":"339",
                        "dollarCost":dollarMoney,
                        "costTypeOnce":"341",
                    }
                    res.tableData.push(totleMoney);
                    // res.graphData = pieData;
                    this.getMes = res;
                    this.tableData = res.tableData;
                    this.getEcharts();
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                this.getMes.graphData.unshift(this.dimension)
                this.options.dataset.source = this.getMes.graphData;
                myChart.setOption(this.options);
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 40%;
        }
        &>div:nth-child(2){
            width: 60%;
            height:400px;
        }
    }
</style>
